import React from 'react';
import { Link } from 'react-router-dom';
import { useDarkMode } from '../../context/DarkModeContext';
import { usePlatform } from '../../context/PlatformContext';
import { handleImgError } from './constants';
interface SeriesSectionProps {
  book: any;
}
export const SeriesSection = ({
  book
}: SeriesSectionProps) => {
  const {
    darkMode
  } = useDarkMode();
  const {
    isAfterTide
  } = usePlatform();
  if (!book.series) return null;
  const seriesSlug = book.series.name.toLowerCase().replace(/\s+/g, '-');
  const seriesLink = isAfterTide ? `/aftertide/series/${seriesSlug}` : `/series/${seriesSlug}`;
  return <div className={`rounded-lg border overflow-hidden mb-8 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`} data-id="element-7449" data-mp="57yeblige56s">
      <div className={`px-6 py-4 border-b flex items-center justify-between ${darkMode ? 'border-gray-700' : 'border-gray-200'}`} data-id="element-7450" data-mp="5z9s8az9289">
        <h3 className={`text-lg font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-7451" data-mp="3nc9u2d5f1fpd">
          {book.series.name}
        </h3>
        <Link to={seriesLink} className={`text-sm font-medium ${darkMode ? 'text-indigo-400 hover:text-indigo-300' : 'text-indigo-500 hover:text-indigo-700'}`} data-id="element-7452" data-mp="3psdbd93i0fud">
          View full series →
        </Link>
      </div>
      <div className="px-6 py-5" data-id="element-7453" data-mp="3kubp6fas00eo">
        <div className="flex gap-4 overflow-x-auto pb-2 px-1 scrollbar-hide" data-id="element-7454" data-mp="3kvd2kqf9kyzk">
          {book.series.books?.map((seriesBook: any) => {
          const bookLink = isAfterTide ? `/aftertide/book/${seriesBook.id}` : `/book/${seriesBook.id}`;
          return <Link key={seriesBook.id} to={bookLink} onClick={e => {
            if (seriesBook.id === book.id) {
              e.preventDefault();
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }
          }} className={`flex-shrink-0 group`} data-id="element-7455" data-mp="3e2drfdroq4d">
                <div className={`relative w-28 sm:w-32`} data-id="element-7456" data-mp="tovw8r6sy4gg">
                  {/* Cover Image */}
                  <div className={`relative rounded-lg shadow-sm ${seriesBook.id !== book.id ? 'overflow-hidden group-hover:shadow-md transition-shadow duration-200' : 'overflow-hidden ring-2 ring-inset ring-indigo-700'}`} data-id="element-7457" data-mp="oxmd89frdzdj">
                    <img src={seriesBook.coverImage || 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80'} alt={seriesBook.title} className={`w-full aspect-[2/3] object-cover ${seriesBook.coming_soon ? 'opacity-60 grayscale-[20%] group-hover:opacity-75 transition-opacity duration-200' : ''}`} onError={handleImgError} data-id="element-7458" data-mp="fv4nvm4t4qmb" />
                    {/* Coming Soon Overlay */}
                    {seriesBook.coming_soon && <div className="absolute inset-0 flex items-center justify-center" data-id="element-7459" data-mp="27vsfxorhf9fr">
                        <span className="bg-amber-500 text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-sm" data-id="element-7460" data-mp="2cn0luatlsco6">
                          Coming Soon
                        </span>
                      </div>}
                    {/* Book position badge */}
                    <div className={`absolute top-1.5 left-1.5 text-[10px] font-bold uppercase tracking-wide bg-black/60 text-white px-1.5 py-0.5 rounded z-10`} data-id="element-7461" data-mp="1oyr4pm7c4d3d">
                      #{seriesBook.position}
                    </div>
                  </div>
                </div>
              </Link>;
        })}
        </div>
      </div>
    </div>;
};
export default SeriesSection;